import { DRIVERS_STANDINGS, TEAMS_STANDINGS } from '../typings/motorsports-standings';
import {
  RACE_STATUS_PLAYING,
  RACE_STATUS_CANCELLED,
  RACE_STATUS_PLAYED,
  RACE_STATUS_POSTPONED,
  RACE_STATUS_SUSPENDED,
  FREE_PRACTICE_ONE,
  FREE_PRACTICE_TWO,
  FREE_PRACTICE_THREE,
  FREE_PRACTICE_FOUR,
  QUALIFYING_ONE,
  QUALIFYING_TWO,
  QUALIFYING_THREE,
  QUALIFYING_GROUP,
  WARMUP,
  RACE,
  RACE_ONE,
  RACE_TWO,
  // ISS-4730 - SPRINT RACE
  RACE_SPRINT,
  QUALIFYING_SPRINT,
  STARTING_GRID_SPRINT,
  STARTING_GRID,
  SHOOTOUT_SPRINT_GROUP,
  SHOOTOUT_SPRINT_ONE,
  SHOOTOUT_SPRINT_TWO,
  SHOOTOUT_SPRINT_THREE,
} from '../typings/race-session';
import t from '../labels/labelling-utils';
import { Sport } from '../typings/motorsports';

import { hasValueInUrl } from './urls-utils';

export const getRaceSessionStatus = (showCta: boolean = true) => ({
  [RACE_STATUS_CANCELLED]: t('motorsports.calendar.gp.sessions.status.cancelled'),
  [RACE_STATUS_PLAYED]: showCta ? t('motorsports.calendar.gp.sessions.status.played') : t('match.time.fulltime'),
  [RACE_STATUS_PLAYING]: t('motorsports.calendar.gp.sessions.status.live'),
  [RACE_STATUS_POSTPONED]: t('motorsports.calendar.gp.sessions.status.postponed'),
  [RACE_STATUS_SUSPENDED]: t('motorsports.calendar.gp.sessions.status.suspended'),
});

export const getSessionLabels = (sportTag?: Sport) => ({
  [FREE_PRACTICE_ONE]: t('motorsports.sessions.tabs.FP1'),
  [FREE_PRACTICE_TWO]: t('motorsports.sessions.tabs.FP2'),
  [FREE_PRACTICE_THREE]: t('motorsports.sessions.tabs.FP3'),
  [FREE_PRACTICE_FOUR]: t('motorsports.sessions.tabs.FP4'),
  [QUALIFYING_GROUP]: t('motorsports.sessions.tabs.Q'),
  [QUALIFYING_ONE]: t('motorsports.sessions.tabs.Q1'),
  [QUALIFYING_TWO]: t('motorsports.sessions.tabs.Q2'),
  [QUALIFYING_THREE]: t('motorsports.sessions.tabs.Q3'),
  [QUALIFYING_SPRINT]: t('motorsports.sessions.tabs.QS'),
  [RACE]: t('motorsports.sessions.tabs.R'),
  [RACE_ONE]: t('motorsports.sessions.tabs.R1'),
  [RACE_TWO]: t('motorsports.sessions.tabs.R2'),
  [RACE_SPRINT]:
    sportTag === 'MOTOGP' || hasValueInUrl('motogp')
      ? t('motorsports.sessions.tabs.SPRINT.motogp')
      : t('motorsports.sessions.tabs.SPRINT'),
  [SHOOTOUT_SPRINT_GROUP]: t('motorsports.sessions.tabs.SS'),
  [SHOOTOUT_SPRINT_ONE]: t('motorsports.sessions.tabs.SS1'),
  [SHOOTOUT_SPRINT_THREE]: t('motorsports.sessions.tabs.SS3'),
  [SHOOTOUT_SPRINT_TWO]: t('motorsports.sessions.tabs.SS2'),
  [STARTING_GRID]: t('motorsports.sessions.tabs.G'),
  [STARTING_GRID_SPRINT]: t('motorsports.sessions.tabs.GS'),
  [WARMUP]: t('motorsports.sessions.tabs.W'),
});

export const getSessionsTabsLabels = () => ({
  ...getSessionLabels(),
  [DRIVERS_STANDINGS]: t('motorsports.sessions.tabs.DS'),
  [STARTING_GRID]: t('motorsports.sessions.tabs.G'),
  [TEAMS_STANDINGS]: t('motorsports.sessions.tabs.TS'),
});

export const getSessionAccordionLabels = () => ({
  [SHOOTOUT_SPRINT_ONE]: t('motorsports.sessions.accordion.SS1'),
  [SHOOTOUT_SPRINT_TWO]: t('motorsports.sessions.accordion.SS2'),
  [SHOOTOUT_SPRINT_THREE]: t('motorsports.sessions.accordion.SS3'),
});

const MOTO_GP: Sport = 'MOTOGP';
const MOTO_2: Sport = 'MOTO2';
const MOTO_3: Sport = 'MOTO3';
const FORMULA_1: Sport = 'F1';

export const getSportLabels = () => ({
  [MOTO_GP]: t('moto.gp'),
  [MOTO_2]: t('moto.2'),
  [MOTO_3]: t('moto.3'),
  [FORMULA_1]: t('f.1'),
});
